import { render, staticRenderFns } from "./GoodsChangeForm.vue?vue&type=template&id=3777a0d4&scoped=true&"
import script from "./GoodsChangeForm.vue?vue&type=script&lang=js&"
export * from "./GoodsChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3777a0d4",
  null
  
)

export default component.exports